import { render, staticRenderFns } from "./permissionrulelist.vue?vue&type=template&id=4da6084c&scoped=true"
import script from "./permissionrulelist.vue?vue&type=script&lang=js"
export * from "./permissionrulelist.vue?vue&type=script&lang=js"
import style0 from "./permissionrulelist.vue?vue&type=style&index=0&id=4da6084c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6084c",
  null
  
)

export default component.exports